<template>
    <b-card header-tag="header"
            header-class="text-center"
            header-bg-variant="primary"
            class="mb-3">
        <div slot="header">{{ openTasksNumber }} {{ $tc('project.opentask', openTasksNumber) }}</div>    
        <p v-if="openTasksNumber < 1">{{ $t('project.noOpenTasks') }}</p>
        <ul class="list-unstyled">
            <li v-for="list in project.assignedTaskLists" :key="list.id">
                <router-link :to="{ name: 'project-tasks', query: { listId: list.id } }" class="task-list-name">{{ list.name }} ({{ list.tasks.length }})</router-link>
                <ul class="pl-3">
                    <li v-for="task in list.tasks" :key="task.id">
                        <b-row class="mb-2">
                            <b-col cols="7">
                                <span>{{ task.subject }}</span>
                            </b-col>
                            <b-col cols="5" class="text-right">
                                <b-badge><small>{{ taskDue(task) }}</small></b-badge>
                            </b-col>
                        </b-row>
                    </li>
                </ul>
            </li>
        </ul>
    </b-card>
</template>

<script>
import { mapFilters } from '@/filters/mapFilters';

export default {
    computed: {
        project() {
            return this.$store.state.projects.currentProject;
        },
        openTasksNumber() {
            return this.$store.getters['projects/openTasksNumber'];
        }
    },
    methods: {
        ...mapFilters(['formatDate']),
        taskDue(task) {
            if (!task.due) {
                return this.$t('tasks.dueNotSet');
            } else {
                return this.$t('tasks.due') + ' ' + this.formatDate(task.due);
            }
        }
    },
    created() {
        var projectId = this.$route.params.projectId;
        this.$store.dispatch('projects/loadProjectAssignedTaskLists', { projectId });
    }
}
</script>

<style lang="scss" scoped>
    .task-list-name {
        display: inline-block;
        margin-bottom: 10px;
    }
</style>
